const isMac =
  typeof navigator !== 'undefined' &&
  /mac/i.test(navigator.platform);

export function modKey(): 'Meta' | 'Control' {
  return isMac ? 'Meta' : 'Control';
}

export function modKeyLabel(): string {
  return isMac ? 'Cmd' : 'Ctrl';
}

export function isModKey(e: KeyboardEvent): boolean {
  return isMac ? e.metaKey : e.ctrlKey;
}
